<div class="container-fluid " style="background-color: #d0d0d0">
 <!-- style="background-image: url('assets/images/city-bg-01.jpg')"> -->
     <!-- url('assets/images/login-bg.jpg')"> -->

     <div class="container">
        <div class="row">
            <div class="login-left text-left align-self-center col-xl-5 col-md-6 col-xs-12">
                <!-- <img src="assets/images/logo.png" alt=""> -->
                <div class="m-3">&nbsp;</div>
                <p>Welcome Back, Please login</p>
                {{message}}
                <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                    <div class="form-group" [ngClass]="{ 'is-invalid': (submitted && f.email.errors) || emailFocus }">
                        <input id="EmailAddress" formControlName="email" type="text" 
                                required (focus)="autofocus('email')" class="form-control" 
                                [ngClass]="{ 'is-invalid': submitted && f.email.errors }" 
                                [autofocus]="true"
                                autofocus>

                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                            <div *ngIf="f.email.errors.required">Email is required</div>
                            <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
                        </div>
                        <label for="EmailAddress">Enter Your Email</label>
                    </div>

                    <div class="form-group" [ngClass]="{ 'is-invalid': (submitted && f.password.errors) || passwordFocus}">
                        <input id="Password" formControlName="password" type="password" required class="form-control" (focus)="autofocus('password')" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                            <div *ngIf="f.password.errors.required">Password is required</div>
                            <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div>
                        </div>
                        <label for="Password">Password</label>
                    </div>
                  <div class="error" *ngIf="serverError != ''">{{serverError}}</div>
                  <div class="notice" *ngIf="notice" style="color:#1a7f37; font-size:13px; margin:6px 0;">{{notice}}</div>


                    <div class="row justify-content-between checkbox-sec">
                        <div class=" col-12 col-sm-auto align-self-start ">
                            <div class="form-check">
                                <input type="checkbox" formControlName="check" class="form-check-input" id="exampleCheck1">
                                <label class="form-check-label" for="exampleCheck1">Remember me</label>
                            </div>

                        </div>
                        <div class="col-12 col-sm-auto ml-auto align-self-end text-right text-left-mob">
                            <a href="javascrpt:void(0);" [routerLink]="['/forgot-password']">Forgot Password?</a>
                        </div>
                    </div>

                    <button type="submit" class="btn btn-dark" value="Login">Login</button>
                </form>
                <div class="sso-block">
                    <div class="sso-divider"><span>or</span></div>
                    <button type="button" class="btn-sso" *ngFor="let provider of ssoProviders"
                            (click)="loginWithSso(provider.slug)">
                        Log in with {{ provider.display_name }}
                    </button>
                </div>
            </div>
            <div class="login-right col-xl-7 col-sm-6 d-none d-md-block  " style="background-image: url('assets/images/minneapolis-skyline.jpg')">
            </div>
        </div>
    </div>
</div>


<!--  

<div class="limiter">
        <div class="container-login100" style="background-image: url('assets/images/city-bg-01.jpg');">
            <div class="wrap-login100">
                <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="login100-form">
                    <span class="login100-form-logo">
                        <i class="zmdi zmdi-landscape"></i>
                    </span>
    
                    <span class="login100-form-title p-b-34 p-t-27">
                        Log in
                    </span>
    
                    {{message}}
                    <div class="form-group wrap-input100" [ngClass]="{ 'is-invalid': (submitted && f.email.errors) || emailFocus }">
                        <input id="EmailAddress" formControlName="email" type="text" 
                                required (focus)="autofocus('email')" 
                                class="form-control input100" 
                                [ngClass]="{ 'is-invalid': submitted && f.email.errors }" 
                                pattern='^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$'
                                [autofocus]="true"
                                autofocus>
        
                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                            <div *ngIf="f.email.errors.required">Email is required</div>
                            <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
                        </div>
                        <label for="EmailAddress">Enter Your Email</label>
                    </div>
        
                    <div class="form-group wrap-input100" [ngClass]="{ 'is-invalid': (submitted && f.password.errors) || passwordFocus}">
                        <input id="Password" formControlName="password" 
                                type="password" required 
                                class="form-control wrap-input100" (focus)="autofocus('password')" 
                                [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                            <div *ngIf="f.password.errors.required">Password is required</div>
                            <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div>
                        </div>
                        <label for="Password">Password</label>
                    </div>
                    <div class="error" *ngIf="serverError != ''">{{serverError}}</div>
        
                    <div class="contact100-form-checkbox">
                        <input class="input-checkbox100" id="ckb1" type="checkbox" name="remember-me">
                        <label class="label-checkbox100" for="ckb1">
                            Remember me
                        </label>
                    </div>                
                        
                    <div class="container-login100-form-btn">
                        <button type="submit" class="btn btn-default" value="Login">
                            Login
                        </button>
                    </div>
    
                    <div class="text-center p-t-30">
                        <a class="txt1" href="javascrpt:void(0);" [routerLink]="['/forgot-password']">
                            Forgot Password
                        </a>
                    </div>
    
                </form>
            </div>
        </div>
    </div>
                    
                    
    
    
    
    
    
     -->
    